export { WordMorphemePanelsView } from "#word-morpheme-panels-view";
